import React, { useEffect, useState } from "react";
import CSS from "./CSS";
import { useSession } from "./Session";
import { useTemplate } from "./Template";
import { apiCall } from "./Api";
import { message } from "antd";
import { usePrefs } from "./Prefs";

export const getPadding = (_y, _x) => {
    return `padding : ${_y}px ${_x}px !important;`;
}

export const getMargin = (_y, _x) => {
    return `margin : ${_y}px ${_x}px !important;`;
}

export default function StyleInjector(props) {

    const { firstLoad = false, setStylesheet = () => { } } = props;
    const [init, setInit] = useState(true);
    const [template,] = useTemplate();
    const [session,] = useSession();
    const [prefs,] = usePrefs();

    let site_path = "https://bookmanager.com/i/" + session.webstore_name;

    const styles = [
        { id: 1, label: "Regular", weight: "normal", style: "normal" },
        { id: 2, label: "Italic", weight: "normal", style: "italic" },
        { id: 3, label: "Bold", weight: "bold", style: "normal" },
        { id: 4, label: "Bold Italic", weight: "bold", style: "italic" }
    ]

    // Get style by id 
    const getStyle = (_id) => {
        let _s = styles.find(item => item.id === _id);
        if (_s) {
            return `font-weight: ${_s.weight} !important; font-style: ${_s.style} !important;`;
        }
    }

    // get border and border radius
    const getBorderCSS = (_size, _radius, _color, _l = true, _r = true, _t = true, _b = true) => {
        // no size, just return
        if (!_size && !_radius) { return `border : none !important;  border-radius: 0px !important;` }

        let _c = getColor(_color);
        let ret = `border-radius: ${_radius}px !important;`;
        if (_l && _r && _t && _b) {
            ret += `border: ${_size}px solid ${_c} !important;`
        } else {
            if (_l) { ret += `border-left: ${_size}px solid ${_c}  !important;`; }
            if (_r) { ret += `border-right: ${_size}px solid ${_c} !important;`; }
            if (_t) { ret += `border-top: ${_size}px solid ${_c} !important;`; }
            if (_b) { ret += `border-bottom: ${_size}px solid ${_c} !important;`; }
        }
        return ret;
    }

    // Get letter spacing
    const getLetterSpacing = (_ls) => {
        let _l = (_ls) ? _ls / 10 : 0;
        return `letter-spacing: ${_l}px !important;`;
    }

    const toUnitless = (_per) => {
        if (typeof _per !== 'number') {
            return 1.2;
        }
        if (_per === 0) {
            return 0;
        }
        return (_per / 100).toFixed(2);
    }

    // Get letter spacing
    const getLineHeight = (_ls) => {
        return `line-height: ${toUnitless(_ls)} !important;`;
    }

    // Get drop shadow
    const getDropShadow = (x, y, blurRadius, spread, color) => {
        if (!x && !y && !blurRadius) {
            return `box-shadow: none !important;`;
        }
        let _c = getColor(color);
        return `box-shadow: ${x}px ${y}px ${blurRadius}px ${spread}px ${_c} !important;`;
    }

    // Get drop shadow
    const getBoxShadow = (x, y, blurRadius, spread, color) => {
        if (!x && !y && !blurRadius) {
            return `box-shadow: none !important;`;
        }
        let _c = getColor(color);
        return `box-shadow: ${x}px ${y}px ${blurRadius}px ${spread}px ${_c} !important;`;
    }

    // Get text shadow
    const getTextShadow = (x, y, blurRadius, color) => {
        if (!x && !y && !blurRadius) {
            return `text-shadow: none !important;`;
        }
        let _c = getColor(color);
        return `text-shadow: ${x}px ${y}px ${blurRadius}px ${_c} !important;`;
    }

    // Get underline
    const getUnderline = (_bool, _color = false) => {
        let ret = (_bool) ? `text-decoration: underline !important;` : `text-decoration: none !important;`;
        if (_color) {
            ret += `text-decoration-color: ${getColor(_color)} !important;`
        }
        return ret;
    }

    // Get colour by id
    const getColor = (_id, _default = "rgba(0, 0, 0, 1)", fakeGradient = false) => {
        let _f;
        if (_id % 2) {
            // colour
            _f = template.colours.find(item => item.id === _id);
            const color = _f ? _f.style : _default;
            if (fakeGradient) {
                return `linear-gradient(180deg, ${color} 0%, ${color} 100%)`;
            }
            return color;

        } else {
            // gradient
            _f = template.gradients.find(item => item.id === _id);
            return (_f) ? _f.style : _default;
        }
    }

    const getFont = (_id, _default = "") => {
        let _f = template.fonts.find(item => item.id === _id);
        // found
        if (_f) {
            if (_f.is_import) {
                return extract(_f.path);
            }
            return _f.name;
        }
        // set default if set
        if (_default) {
            return _default;
        }
        // set base font if no default is set
        if (template.base_font) {
            let _bf = template.fonts.find(item => item.id === template.base_font);
            if (_bf) {
                return _bf.name;
            }
        }
        // all else fails, set the system font
        return 'Default';
    }


    const injectLinks = (_raw = false) => {
        let _ret = ``;

        _ret += `
        .bm-lnk-0, .bm-component .bm-lnk-0, .bm-lnkin-0 a, .bm-component .bm-lnkin-0 a{
            color: ${getColor(0, "#000")} !important;
            text-decoration: none !important;
            font-weight: normal !important; font-style: normal !important;
        }
        `;

        _ret += `
        .bm-lnk-0:hover, .bm-component .bm-lnk-0:hover, .bm-lnkin-0 a:hover, .bm-component .bm-lnkin-0 a:hover{
            color: ${getColor(0, "#000")} !important;
            text-decoration: underline !important;
            font-weight: normal !important; font-style: normal !important;
        }
        `;

        template.links.forEach(link => {

            _ret += `
        .bm-lnk-${link.id}, .bm-component .bm-lnk-${link.id}, .bm-lnkin-${link.id} a, .bm-component .bm-lnkin-${link.id} a{
            color: ${getColor(link.init_colour, "#000")} !important;
            ${getUnderline(link.init_underline)}
            ${getStyle(link.init_style)}
        }
        `;

            _ret += `
        .bm-lnk-${link.id}:hover, .bm-component .bm-lnk-${link.id}:hover, .bm-lnkin-${link.id} a:hover, .bm-component .bm-lnkin-${link.id} a:hover{
            color: ${getColor(link.hover_colour, "#000")} !important;
            ${getUnderline(link.hover_underline)}
            ${getStyle(link.hover_style)}
        }
        `;

        });
        return (_raw) ? _ret : <CSS html={_ret} />
    }


    const injectButtons = (_raw = false) => {
        let _ret = ``;

        _ret += `
        .bm-btn-0 {
            margin: 6px !important;
            transition: none !important;
            transition: background 0.2s ease, color 0.2s ease !important;
            cursor : pointer !important;
            height : auto !important;
            padding : 5px 10px !important;
            border : none !important;
            font-family: '${getFont(0)}' !important;
            font-size : 14px !important;
            color: ${getColor(0, "#fff")} !important;
            background: ${getColor(0, "#000", true)} !important;
        }
        `;

        _ret += `
        .bm-btn-0:hover, .bm-btn-0:active, .bm-btn-0:focus {
            outline : none !important;
            color: ${getColor(0, "#000")} !important;
            background: ${getColor(0, "#fff", true)} !important;
        }
        `;

        template.buttons.forEach(button => {
            // init
            _ret += `
        .bm-btn-${button.id} {
            transition: none !important;
            transition: background 0.2s ease, color 0.2s ease !important;
            cursor : pointer !important;
            height : auto !important;
            ${getPadding(button.init_padding_y, button.init_padding_x)}
            ${getMargin(button.init_margin_y, button.init_margin_x)}
            font-family: '${getFont(button.init_font)}' !important;
            font-size : ${button.init_size}px !important;
            ${getLetterSpacing(button.init_letter_spacing)}
            color: ${getColor(button.init_colour, "#fff")} !important;
            ${getBorderCSS(button.init_border_size, button.init_border_radius, button.init_border_colour)}
            ${getStyle(button.init_style)}
            ${getBoxShadow(button.init_drop_shadow_x, button.init_drop_shadow_y, button.init_drop_shadow_blur, button.init_drop_shadow_spread, button.init_drop_shadow_colour)}
            background: ${getColor(button.init_background_colour, "#000", true)} !important;
        }
        `;
            // hover, active, focus states
            _ret += `
        .bm-btn-${button.id}:hover, .bm-btn-${button.id}:active, .bm-btn-${button.id}:focus {
            color: ${getColor(button.hover_colour, "#000000")} !important;
            ${getBorderCSS(button.hover_border_size, button.hover_border_radius, button.hover_border_colour)}
            ${getStyle(button.hover_style)}
            ${getBoxShadow(button.hover_drop_shadow_x, button.hover_drop_shadow_y, button.hover_drop_shadow_blur, button.hover_drop_shadow_spread, button.hover_drop_shadow_colour)}
            background: ${getColor(button.hover_background_colour, "#ffffff", true)} !important;
        }
        `;
        });
        return (_raw) ? _ret : <CSS html={_ret} />
    }

    const injectText = (_raw = false) => {
        let _ret = ``;

        _ret += `
        .bm-txt-0, [class^="bm-txt-"] {
            font-family: '${getFont(template.base_font)}' !important;
        }
        `;

        template.texts.forEach(text => {
            // init
            _ret += `
        .bm-txt-${text.id} {
            display: ${(text.background_visible) ? 'inline-block' : 'block'} !important;
            font-family: '${getFont(text.font)}' !important;
            font-size : ${text.font_size}px !important;
            text-transform : ${text.text_transform} !important;
            ${getUnderline(text.underlined, text.underline_colour)}
            ${getPadding(text.padding_y, text.padding_x)}
            ${getLetterSpacing(text.letter_spacing)}
            ${getLineHeight(text.line_height)}
            ${getTextShadow(text.text_shadow_x, text.text_shadow_y, text.text_shadow_blur, text.text_shadow_colour)}
            color: ${getColor(text.colour, "#000")};
            ${getBorderCSS(text.border_size, text.border_radius, text.border_colour, text.border_left, text.border_right, text.border_top, text.border_bottom)}
            ${getStyle(text.font_style)}
            background: ${(text.background_visible) ? getColor(text.background_colour) : 'initial'};
            ${getDropShadow(text.background_shadow_x, text.background_shadow_y, text.background_shadow_blur, text.background_shadow_spread, text.background_shadow_colour)}
        }
        `;


            // CSS ONLY
            if (_raw && text.allow_mobile_overrides) {
                _ret += `
                    @media only screen and (max-width: 716px) {
                        .bm-txt-${text.id}, [class^="bm-txt-${text.id}"] {
                            font-size : ${text.mobile_font_size}px !important;
                            ${getPadding(text.mobile_padding_x, text.mobile_padding_y)}
                            ${getLineHeight(text.mobile_line_height)}
                        }
                    }
                `;

            }

            // WEBSTORE DESIGNER (CLASS)
            if (!_raw && text.allow_mobile_overrides) {

                _ret += `
                    .bm_mobile .bm-txt-${text.id}, .bm_mobile [class^="bm-txt-${text.id}"] {
                        font-size : ${text.mobile_font_size}px !important;
                        ${getPadding(text.mobile_padding_y, text.mobile_padding_x)}
                        ${getLineHeight(text.mobile_line_height)}
                    }
                    `;
            }

        });
        return (_raw) ? _ret : <CSS html={_ret} />
    }

    const injectLink = (_raw = false) => {
        let _ret = ``;

        _ret += `
        .bm-link, .bm-component .bm-link {
            color: ${getColor(template.link_init_colour)};
            ${getStyle(template.link_init_style)}
            ${getUnderline(template.link_init_underline)}
        }
        `;

        _ret += `
        .bm-link:hover, .bm-component .bm-link:hover {
            color: ${getColor(template.link_hover_colour)};
            ${getStyle(template.link_hover_style)}
            ${getUnderline(template.link_hover_underline)}
        }
        `;

        // For paragraphs with links
        _ret += `
        .bm-anchor a, .bm-component .bm-anchor a{
            color: ${getColor(template.link_init_colour)};
            ${getStyle(template.link_init_style)}
            ${getUnderline(template.link_init_underline)}
        }
        `;

        _ret += `
        .bm-anchor a:hover, .bm-component .bm-anchor a:hover {
            color: ${getColor(template.link_hover_colour)};
            ${getStyle(template.link_hover_style)}
            ${getUnderline(template.link_hover_underline)}
        }
        `;

        return (_raw) ? _ret : <CSS html={_ret} />
    }

    const extract = (_import) => {
        var regex = /family=([a-z1-9+]+)[:&]/i;
        var match = regex.exec(_import);
        if (match.length > 1) {
            return match[1].split('+').join(' ');
        }
        return "";
    }

    const injectFonts = (_raw = false, _imports = false) => {
        let _ret = ``;

        // _ret += `
        // .bm-font-0 {
        //     font-family: "Default";
        // }
        // `;

        if (_imports) {
            // put the imports first...
            template.fonts.forEach(font => {
                if (font.is_import) {
                    _ret += font.path;
                    _ret += `
                    `;
                }
            })
            return (_raw) ? _ret : <CSS html={_ret} />
        }

        template.fonts.forEach(font => {

            if (!font.name || !font.path) {
                font.name = "Default";
            }

            if (font.is_import) {
                // _ret += font.path;

                _ret += `
        .bm-font-${font.id} {
            font-family: '${extract(font.path)}';
        }
        `;

            } else {

                // No source needed for websafe fonts...
                let _src = "";
                if (font.path.includes(".")) {

                    if (font.path.includes("/fonts/")) {
                        // hardcoded
                        if (!_raw) {
                            // local 
                            let _p = "/create/" + font.path;

                            _src = `\n\t\t\tsrc: url('${_p}');`
                        } else {
                            _src = `\n\t\t\tsrc: url('${font.path}');`
                        }

                    } else {
                        _src = `\n\t\t\tsrc: url('${site_path + font.path}');`
                    }

                }

                _ret += `
        @font-face {
            font-family: '${font.name}'; ${_src}
        }
        `;

                _ret += `
        .bm-font-${font.id} {
            font-family: '${font.name}';
        }
        `;

            }

        });

        return (_raw) ? _ret : <CSS html={_ret} />
    }

    const injectBackground = (_raw = false) => {

        let _ret = ``;

        _ret += `
        .bm-background-color{
            background: ${getColor(template.background_colour, "#f0f2f5")} !important;
        }    
        `

        if (template.background_image && template.background_image !== "undefined") {
            _ret += `
        .bm-background{
            background-image: url(${site_path + template.background_image}) !important; 
            background-attachment: ${(template.background_fixed) ? "fixed" : "scroll"} !important;
            background-repeat : ${(template.background_tile) ? "repeat" : "no-repeat"} !important;
        }    
        `
        }

        if (template.background_container_transparent) {
            _ret += `
        .preview-container {
            background: transparent !important;
        }
        `

        } else {
            _ret += `
        .preview-container {
            background: ${getColor(template.background_container_colour, "#fff")} !important;
        }
        `
        }

        return (_raw) ? _ret : <CSS html={_ret} />

    }


    const injectColours = (_raw = false) => {

        let _ret = ``;
        template.colours.forEach(colour => {

            _ret += `
            .bm-colour-${colour.id} {
                color: ${colour.style};
            }
            .bm-highlight-${colour.id} {
                background-color: ${colour.style};
            }
            
            `;

        })
        return (_raw) ? _ret : <CSS html={_ret} />
    }


    const injectSiteText = (_raw = false) => {
        let _ret = ``;

        _ret += `
        .bm-render{
            font-family: '${getFont(template.base_font)}';
        }    
        `
        // _ret += `
        // .bm-img{
        //     margin: 10px;
        // }    
        // `

        return (_raw) ? _ret : <CSS html={_ret} />

    }


    const updateStyleSheet = () => {

        if (init && !firstLoad) {
            setInit(false);
            return;
        }

        if (template.is_active && !prefs.changed) {

            let s = injectFonts(true, true);
            s += injectFonts(true);
            s += injectSiteText(true);
            s += injectButtons(true);
            s += injectLinks(true);
            s += injectText(true);
            s += injectLink(true);
            s += injectBackground(true);
            s += injectColours(true);


            setStylesheet(s);
            apiCall("site_content/setCssStyleSheet", { style: s }, (_status, _result) => {
                if (_status) {
                    if (init && firstLoad) {
                        message.success("CSS File created");
                        setInit(false);
                    } else {
                        message.success("CSS Updated")
                    }

                } else {
                    message.error(_result.error)
                }
            })
        }
    }

    useEffect(updateStyleSheet, [prefs.changed, template.id, template.is_active])




    return (
        <>
            {injectSiteText(false)}
            {injectFonts(false, true)}
            {injectFonts(false)}
            {injectButtons(false)}
            {injectLinks(false)}
            {injectText(false)}
            {injectLink(false)}
            {injectBackground(false)}
            {injectColours(false)}
        </>
    );


}